import axios from 'axios';
import { useQuery } from 'react-query';

const useGetArchivedStandardizationProjects = () => {
  const { data, isLoading, isRefetching } = useQuery(
    'archivedStandardizationProjects',
    async () => {
      const projects = (await axios.get('/standardization/?archived=true')).data;

      return projects.map((project) => ({
        ...project,
      }));
    },
    { refetchOnMount: true }
  );

  return {
    archivedStandardizationProjects: data,
    isLoading: isLoading || isRefetching,
  };
};

export default useGetArchivedStandardizationProjects;
